// extracted by mini-css-extract-plugin
export default {"dropdown":"templates-hotel-benchmark-insight-module__dropdown","dropdown-reference-period":"templates-hotel-benchmark-insight-module__dropdown-reference-period"};